import {
  Anchor,
  Button,
  CloseButton,
  Divider,
  Group,
  Stack,
  ThemeIcon,
} from "@mantine/core";
import EmailSmtp from "./EmailSmtp";
import PageTitle from "../../../../../components/View/PageTitle";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IconPlaylistAdd } from "@tabler/icons-react";

const CreateSmtpPage = () => {
  const { poolId } = useParams();
  const lang = useLanguage((s) => s.language);

  const navigate = useNavigate();
  const handleClose = () => {
    if (poolId) {
      navigate(`/senders/pool/${poolId}/email/none`);
    } else {
      navigate(`/senders/email/none`);
    }
  };

  return (
    <Stack
      mx={"auto"}
      mt={32}
      p={16}
      mb={32}
      gap={"xs"}
      w={"80%"}
      style={{
        boxShadow: "#00000016 0 2px 6px",
        background: "#fff",
        borderRadius: 12,
        width: "90%",
      }}
      h={"calc(100vh - 128px)"}
    >
      <CloseButton size={40} onClick={handleClose} />
      <Group align="center">
        <PageTitle title={lang.emails_account.create.button_tooltip} />

        <Group ml={"auto"}>
          <Button
            variant="light"
            leftSection={<IconPlaylistAdd />}
            component={Link}
            to={"/senders/email/import/smtp"}
            size="md"
          >
            {lang.emails_account.create.button_import}
          </Button>
        </Group>
      </Group>
      <Divider />
      <EmailSmtp handleClose={handleClose} onEdited={handleClose} />
    </Stack>
  );
};

export default CreateSmtpPage;
